import React from "react";
import { DashboardLoading } from "../../Elements/ServeLoading";
import { createPortal } from "react-dom";
import {
  formatDate,
  formatDate2,
} from "../../../../../CommonFunction/FormatedDate";
import { BsBoxArrowUpRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const BankNotificationModal = ({
  data,
  messageOpen,
  closeMessage,
  msgType,
}) => {
  const navigate = useNavigate();

  const handleNavigation = (data, id) => {
    closeMessage();
    if (msgType === "notice") {
      if (data === "serve") {
        navigate("/banking/bankDashboard/serviceNotice", {
          state: { id },
        });
      } else {
        navigate("/banking/bankDashboard/loanSearch", {
          state: { id },
        });
      }
    } else {
      if (data === "loan") {
        navigate("/banking/bankDashboard/POD", {
          state: { id: id, type: data },
        });
      } else {
        navigate("/banking/bankDashboard/POD", {
          state: { id: id, type: data },
        });
      }
    }
  };

  return createPortal(
    <>
      {messageOpen && (
        <div
          onClick={() => closeMessage()}
          className="font-avenir fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50 backdrop-blur-sm px-2"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-md w-full max-w-[600px] max-h-[90vh] overflow-y-auto"
          >
            <div className="text-bgclr">
              {data?.length <= 0 ? (
                <div className="h-[320px] flex justify-center items-center">
                  <DashboardLoading />
                </div>
              ) : (
                <>
                  {msgType === "notice" && (
                    <div>
                      {/* Header */}
                      <div className="flex justify-between items-center font-semibold py-2 px-4 sm:px-5">
                        <h1 className="text-[18px]">Notice</h1>
                        <button
                          onClick={() => closeMessage()}
                          className="text-[20px]"
                        >
                          x
                        </button>
                      </div>
                      <hr className="shadow-md" />

                      {/* Avatar & Title */}
                      <div className="flex items-center gap-4 px-4 sm:px-5 pt-3">
                        <div className="font-semibold">
                          <img
                            src="https://cdn.clevdoc.com/assets/dashboard/user/user_avatar.png"
                            alt="N"
                            className="w-10 sm:w-12"
                          />
                        </div>
                        <div>
                          <h2 className="text-[16px] sm:text-[20px] font-[600] text-gray-700">
                            Action Required for loan:{" "}
                            <span className="font-[500]">
                              {data?.identity_number}
                            </span>
                          </h2>
                        </div>
                      </div>

                      {/* Body Text */}
                      <div className="px-4 sm:px-5 py-2.5 text-gray-500 text-sm sm:text-base">
                        <p>
                          <span className="font-bold">Reminder:</span> Loan{" "}
                          <span className="font-semibold">
                            {data?.identity_number}
                          </span>{" "}
                          has been in{" "}
                          <span className="font-semibold">
                            {data?.lastStatusType}
                          </span>{" "}
                          default since{" "}
                          <span className="font-semibold">
                            {formatDate2(data?.statusChangeDate)}
                          </span>
                          . No payment received.
                        </p>
                        <p>
                          <span className="font-bold">Action Needed:</span> Serve{" "}
                          <span className="font-semibold">
                            {data?.nextNoticeServe?.join(", ")}
                          </span>{" "}
                          notice immediately to stay compliant and on schedule.
                        </p>
                      </div>

                      {/* Loan/Borrower Details */}
                      <div className="flex flex-col sm:flex-row border border-gray-300 rounded-md text-gray-700 mx-4 sm:mx-5 mb-4 mt-2 py-3 px-4 sm:px-5 gap-4 sm:gap-0">
                        <div className="sm:w-1/2 sm:border-r border-gray-300 sm:pr-4">
                          <h1 className="font-semibold text-[16px] mb-1">Loan Details:</h1>
                          <div className="ml-1 sm:ml-3 text-[14px] space-y-1">
                            <p>Loan no.: <span>{data?.identity_number}</span></p>
                            <p>Loan Amt.: <span>Rs. {data?.amount}</span></p>
                          </div>
                        </div>
                        <div className="sm:w-1/2">
                          <h1 className="font-semibold text-[16px] mb-1 sm:ml-3">Borrower Details:</h1>
                          <div className="ml-1 sm:pl-6 text-[14px] space-y-1">
                            <p>
                              Name:{" "}
                              <span>
                                {data?.associatedUserborrower[0]?.name ||
                                  data?.associatedOrganizationborrower[0]?.name}
                              </span>
                            </p>
                            <p>
                              UCID:{" "}
                              <span>
                                {data?.associatedUserborrower[0]?.system_id ||
                                  data?.associatedOrganizationborrower[0]?.system_id}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Footer Action Buttons */}
                      <hr className="shadow-md" />
                      <div className="flex flex-col sm:flex-row justify-between py-2 text-sm">
                        <div className="flex justify-center items-center border-b sm:border-b-0 sm:border-r border-gray-300 w-full sm:w-[50%]">
                          <button
                            onClick={() =>
                              handleNavigation("status", data?.identity_number)
                            }
                            className="flex items-center gap-2 py-2 hover:underline"
                          >
                            Check Status <BsBoxArrowUpRight />
                          </button>
                        </div>
                        <div className="flex justify-center items-center w-full sm:w-[50%]">
                          <button
                            onClick={() =>
                              handleNavigation("serve", data?.identity_number)
                            }
                            className="flex items-center gap-2 py-2 hover:underline"
                          >
                            Serve Notice <BsBoxArrowUpRight />
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {msgType === "pod" && (
                    <div>
                      {/* POD Header */}
                      <div className="flex justify-between items-center font-semibold py-2 px-4 sm:px-5">
                        <h1 className="text-[18px]">POD</h1>
                        <button onClick={() => closeMessage()} className="text-[20px]">x</button>
                      </div>
                      <hr className="shadow-md" />

                      {/* Avatar & Title */}
                      <div className="flex items-center gap-4 px-4 sm:px-5 pt-3">
                        <div className="font-semibold">
                          <img
                            src="https://cdn.clevdoc.com/assets/dashboard/user/user_avatar.png"
                            alt="N"
                            className="w-10 sm:w-12"
                          />
                        </div>
                        <div>
                          <h2 className="text-[16px] sm:text-[20px] font-[600] text-gray-700">
                            POD Generated for B3 Notice – Loan ID:{" "}
                            <span className="font-[500]">
                              {data?.loan?.identity_number}
                            </span>
                          </h2>
                        </div>
                      </div>

                      {/* POD Body */}
                      <div className="px-4 sm:px-8 py-2.5 text-gray-500 text-sm sm:text-base">
                        <p>
                          <span className="font-bold">Subject - </span>{" "}
                          {data?.subject}
                        </p>
                        <p>
                          <span className="font-bold">POD Details:</span> A Proof of Delivery (POD) has been successfully generated for the {data?.notices[0]?.type} notice served via IVR, WhatsApp, SMS, and Email to the borrower associated with Loan ID {data?.loan?.identity_number}.
                        </p>
                      </div>

                      {/* Loan/Envelope */}
                      <div className="text-gray-700 mx-4 sm:mx-5 my-2 pb-3 px-4 sm:px-5">
                        <h1 className="font-semibold text-[16px]">
                          Loan ID - {data?.loan?.identity_number}
                        </h1>
                        <h1 className="font-semibold text-[16px]">
                          Envelope ID - {data?.envelope}
                        </h1>
                      </div>

                      <hr className="shadow-md" />
                      <div className="flex flex-col sm:flex-row justify-between py-2 text-sm">
                        <div className="flex justify-center items-center border-b sm:border-b-0 sm:border-r border-gray-300 w-full sm:w-[50%]">
                          <button
                            onClick={() =>
                              handleNavigation("loan", data?.loan?.identity_number)
                            }
                            className="flex items-center gap-2 py-2 hover:underline"
                          >
                            Search by Loan <BsBoxArrowUpRight />
                          </button>
                        </div>
                        <div className="flex justify-center items-center w-full sm:w-[50%]">
                          <button
                            onClick={() =>
                              handleNavigation("envelope", data?.envelope)
                            }
                            className="flex items-center gap-2 py-2 hover:underline"
                          >
                            Search by Envelope ID <BsBoxArrowUpRight />
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>,
    document.getElementById("portal")
  );
};

export default BankNotificationModal;
